module.exports = __webpack_public_path__ + "images/directory/icons/compliant.709c98ab9fefbb170d0f.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/icons/compliant.svg
// module id = tm+Y
// module chunks = 24